import { useEffect, useState } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { handleAddItemToCart } from "../../../actions/shoppingCart";
import handleAlert from "../../../helpers/handleAlert";
import { studyInCart } from "../../../helpers/cart";
import axios from "axios";
import {
  BoxTitle,
  PanelContent,
  ContainerPricing,
  BoxPagoSucursal,
  PriceLinea,
  BoxBgBottom,
  CustomBox,
  BtnPagarAhora,
  PriceDetails,
  BoxPadding,
  Paragraph,
} from "./styles/StylesBannerPaneles";

const imageDesktop =
  "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fassets%2FPanelBanners%2Fdesk.png?alt=media&token=c005dd89-576b-4f35-a4d3-b8fffcc7b0f3";

const imageMobile =
  "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fassets%2FPanelBanners%2Fmob.png?alt=media&token=d01cee8a-ef6c-4e40-88bb-8f5bc3802a75";

const bgImageDesk =
  "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fassets%2FPanelBanners%2FVectorDesk.png?alt=media&token=0e52022b-fdc8-403e-a2fd-2ad19f5356b3";

const bgImage =
  "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fassets%2FPanelBanners%2FVectorMob.png?alt=media&token=7de03ec4-be55-4b36-a10c-c4c7ce86b5ec";

const BgNewService =
  "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fassets%2FPanelBanners%2FVectorSer.png?alt=media&token=56c2efa4-eeb6-4c58-9111-b14bcaade765";

const bgImageBottom =
  "https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2Fassets%2FPanelBanners%2FVectorBot.png?alt=media&token=51a92513-86b0-4196-8858-44e720bbb80e";

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  background: linear-gradient(to right, #5097e3, #0cac8c, #30df99);
  height: 640px;

  @media (min-width: 500px) {
    max-width: 36rem;
    height: 740px;
  }

  @media (min-width: 768px) {
    max-width: 36rem;
    height: 740px;
  }

  @media (min-width: 992px) {
    height: 460px;
    max-width: 64rem;
    background: #fff;
  }

  @media (min-width: 1200px) {
    max-width: 100%;
    height: 460px;
  }

  @media (min-width: 1400px) {
    width: 100%;
  }
`;

export const StyledImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${(props) =>
    props.imageDesktop || "default-desktop-image.jpg"});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
`;

const NewService = styled.div`
  position: absolute;
  top: 70%;
  left: 0;
  width: 234px;
  height: 50px;
  background-image: url(${BgNewService});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 768px) {
    top: 60%;
  }
`;
const NewServiceTxt = styled.span`
  color: #7B8288;
  font-size: 22px;
  font-weight: 500;
  margin-left: 10px;
`;
const BoxPagoLinea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: auto;
  gap: 5px;
  button {
    border: 2px solid #1aa687;
    background-color: #fff;
    color: #1aa687;
    padding: 1px 10px;
    border-radius: 10px;
    outline: none;
    text-align: center;
    font-weight: 700;
    align-self: flex-start;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border: 2px solid transparent;
      background: #1aa687;
      color: #fff;
    }
    @media (min-width: 992px) {
      font-size: 17px;
    }

    @media (min-width: 1200px) {
      font-size: 22px;
      padding: 3px 40px;
    }

    @media (min-width: 1400px) {
    }
  }
`;

const PanelGastricoPediatrico = () => {
  const [local, setLocal] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const idClienteLabopat = useSelector(
    (state) => state.user?.data?.data?.profile?.idClienteLabopat
  );
  const { items } = useSelector((state) => state.shoppingCart);
  const [study, setStudy] = useState({
    name: "",
    description: "",
    id: 0,
    normal_price: 0,
    promo_price: 0,
  });
  const studyId = "panel-gastrointestinal-completo-pediatrico";
  useEffect(() => {
    getInfo();
  }, []);
  const getInfo = async () => {
    try {
      let request = axios.get(
        `https://lpqsystem.com/obtener-estudio/${studyId}/${
          idClienteLabopat ? `${idClienteLabopat}` : "0"
        }`
      );
      let response = await request;
      setStudy({
        ...response.data,
        title: response.data.name,
        price: response.data.promo_price,
        oldPrice: response.data.normal_price,
      });
      if (response.data.categoria == 6) {
        setLocal(true);
      }
      if (response.data.categoria == 9) {
        setLocal(true);
      }
    } catch (error) {
      console.log(error);
      history.push("/not-found");
    }
  };

  const payStudy = () => {
    const exists = studyInCart(study, items);
    if (exists?.exists) {
      handleAlert("warning", exists?.message, "Estudio/paquete ya agregado");
    } else {
      dispatch(handleAddItemToCart(study));
      history.push("/checkoutp");
    }
  };

  const navegarAEstudio = () => {
    history.push('/estudio/panel-gastrointestinal-completo-pediatrico');
  };

  return (
    <>
      <Container backgroundColor="#DBEBFA">
        <Row style={{ height: "100%" }}>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={4}
            xl={5}
            xxl={5}
            style={{ margin: "0", padding: "0", position: "relative" }}
          >
            <img
              className="mt-4 mt-lg-0 d-block d-lg-none"
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
              src={imageMobile}
              alt="panel-gastrointestinal "
            />

            <StyledImage
              className="d-none d-lg-block"
              imageDesktop={imageDesktop}
            />
            <NewService>
              <NewServiceTxt>Nueva prueba</NewServiceTxt>
            </NewService>
          </Col>

          <Col
            className="bg-white"
            xs={12}
            sm={12}
            md={12}
            lg={8}
            xl={7}
            xxl={7}
            style={{ margin: "0", padding: "0" }}
          >
            <CustomBox>
              <PanelContent>
                <BoxTitle
                  className=""
                  bgImage={bgImage}
                  bgImageDesk={bgImageDesk}
                  textColor="#fff"
                >
                  <h1 onClick={navegarAEstudio} style={{ cursor: 'pointer' }}>
                    Panel gastrointestinal completo<br /> (viral y bacteriano) pediátrico
                  </h1>
                </BoxTitle>

                <BoxPadding>
                  <Paragraph>
                    Analizamos 20 tipos de  virus y bacterias causantes <br />
                    de enfermedades gástricas en niños.
                  </Paragraph>

                  <ContainerPricing>
                    <BoxPagoLinea>
                      <PriceLinea>
                        $4,600.00 <small>MXN</small>
                      </PriceLinea>
                      <button onClick={() => payStudy()}>Agendar Toma</button>
                      <PriceDetails>
                        Precio en sucursal y domicilio
                      </PriceDetails>
                    </BoxPagoLinea>
                    <BoxPagoSucursal>
                      <PriceLinea>
                        $4,140.00 <small>MXN</small>
                      </PriceLinea>
                      <BtnPagarAhora onClick={() => payStudy()}>
                        Paga ahora -10%
                      </BtnPagarAhora>
                      <PriceDetails>Precio en línea</PriceDetails>
                    </BoxPagoSucursal>
                  </ContainerPricing>
                </BoxPadding>
                <BoxBgBottom bgImageBottom={bgImageBottom}>
                  <span style={{ color: "#7B8288" }}>
                    *Promoción válida por tiempo limitado
                  </span>
                </BoxBgBottom>
              </PanelContent>
            </CustomBox>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PanelGastricoPediatrico;
